import {openPanelInModal} from "@Components/modal-container/modal-container-reducer";
import {MODALS_IDS} from "@Components/modal-container";
import type {DeleteEventConfirmationPanelProps} from "@Panels/delete-event-confirmation-panel/delete-event-confirmation-panel.types";

export const openDeleteEventConfirmationModal = (props: DeleteEventConfirmationPanelProps): void => {
    window.PMW.redux.store.dispatch(
        openPanelInModal({
            modalId: MODALS_IDS.DELETE_EVENT_CONFIRMATION_MODAL,
            panelProps: props
        })
    );
}